import React from "react";

const STEPS = [
  { key: "setup", label: "Setup" },
  { key: "draft", label: "Draft" },
  { key: "review", label: "Review" },
  { key: "export", label: "Export" },
];

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
    <path
      d="M4 10.5L8 14.5L16 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Steps are gated: `reachedIndex` is the highest unlocked step; clicking beyond
// it is a no-op (unlocked via the "Continue to …" button on the previous step).
const ProposalStepBar = ({
  currentStep = "setup",
  reachedIndex = 0,
  onStepClick = () => {},
  onContinue = () => {},
  actions = null,
}) => {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep);
  const nextStep = STEPS[currentIndex + 1];

  return (
    <div className="flex items-center justify-between px-6 h-12 border-b border-[#0000001F] bg-white flex-shrink-0">
      <div className="flex items-center gap-8">
        {STEPS.map((step, idx) => {
          const isActive = idx === currentIndex;
          const isComplete = idx < reachedIndex;
          const isReachable = idx <= reachedIndex;
          return (
            <button
              key={step.key}
              type="button"
              onClick={() => isReachable && onStepClick(step.key)}
              disabled={!isReachable}
              title={isReachable ? "" : "Complete the previous step to continue"}
              className={`flex items-center gap-2 relative py-3 ${
                isReachable ? "cursor-pointer" : "cursor-not-allowed"
              }`}
            >
              <span
                className={`flex items-center justify-center w-6 h-6 rounded-full text-[12px] font-outfit font-medium ${
                  isActive
                    ? "bg-[#F5EDF4] text-[#A04A97] border border-[#A04A97]"
                    : isComplete
                    ? "bg-[#A04A97] text-white"
                    : "bg-[#BABABA] text-white"
                }`}
              >
                {isComplete ? <CheckIcon /> : idx + 1}
              </span>
              <span
                className={`font-outfit text-base font-medium ${
                  isActive
                    ? "text-[#A04A97]"
                    : isReachable
                    ? "text-[#4D4D4D]"
                    : "text-[#B0B0B0]"
                }`}
              >
                {step.label}
              </span>
              {isActive && (
                <span className="absolute -bottom-[1px] left-0 right-0 h-[2px] bg-[#A04A97]" />
              )}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-2">
        {actions}
        {nextStep && (
          <button
            onClick={onContinue}
            className="px-4 py-1 rounded-md border border-[#A04A97] text-[#A04A97] font-outfit text-[14px] font-medium hover:bg-[#C95EBE0D] transition-colors"
          >
            Continue to {nextStep.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default ProposalStepBar;
